import Axios from 'axios';
import { apiUrl } from './Constants';

const token = JSON.parse(sessionStorage.getItem('AcharyaErpUser'))?.token;

const axios = Axios.create({
  baseURL: apiUrl,
});

axios.interceptors.request.use(config => {
  config.headers.authorization = `Bearer ${token}`;
  config.headers['ngrok-skip-browser-warning'] = true;
  return config;
});

export default axios;
